import { gfs } from '../../utils/functional'
import { keys } from 'ramda'

const VIDEO_CLIP_TITLE = '蝉选直播切片-抖音ip授权带货达人二次创作明星达人直播切片'
const CHANNEL_VIDEO_CLIP_TITLE = '抖音ip授权带货达人二次创作明星达人直播切片'

function getVideoClipTitle(promoteCode) {
  return promoteCode ? CHANNEL_VIDEO_CLIP_TITLE : VIDEO_CLIP_TITLE
}

const UPDATE_SHOW_MOBILE_MESSAGE = 'UPDATE_SHOW_MOBILE_MESSAGE'
const CLEAR_SHOW_MOBILE_MESSAGE = 'CLEAR_SHOW_MOBILE_MESSAGE'
const UPDATE_WORKBENCH_QR_CODE = 'UPDATE_WORKBENCH_QR_CODE'
const UPDATE_CHANNEL_ATTRIBUTION = 'UPDATE_CHANNEL_ATTRIBUTION'
const channelPromoteCode = ''
const state = {
  showMobileMessage: true,
  workBenchQrcode: null,
  channelPromoteCode,
  channelSubChannelId: '',
  isChannelPromoter: !!channelPromoteCode,
  videoClipTitle: getVideoClipTitle(channelPromoteCode)
}
export default {
  namespaced: false,
  state,
  mutations: {
    [UPDATE_SHOW_MOBILE_MESSAGE](state, data) {
      state.showMobileMessage = false
    },
    [CLEAR_SHOW_MOBILE_MESSAGE](state, data) {
      state.showMobileMessage = true
    },
    [UPDATE_WORKBENCH_QR_CODE](state, data) {
      state.workBenchQrcode = data
    },
    [UPDATE_CHANNEL_ATTRIBUTION](state, data = {}) {
      state.channelPromoteCode = data.promoteCode || ''
      state.channelSubChannelId = data.subChannelId || ''
      state.isChannelPromoter = !!state.channelPromoteCode
      state.videoClipTitle = getVideoClipTitle(state.channelPromoteCode)
    }
  },
  actions: {
    upDateShowMobileMessage({ commit }) {
      commit(UPDATE_SHOW_MOBILE_MESSAGE)
    },
    clearShowMobileMessage({ commit }, params) {
      commit(CLEAR_SHOW_MOBILE_MESSAGE, params)
    },
    workbenchQrCodeChange({ commit }, params) {
      commit(UPDATE_WORKBENCH_QR_CODE, params)
    },
    channelAttributionChange({ commit }, params) {
      commit(UPDATE_CHANNEL_ATTRIBUTION, params)
    }
  },
  getters: {
    ...gfs(keys(state))
  }
}
